import { Outlet, Navigate } from "react-router-dom";

const PrivateRoutes = () => {
  let role = localStorage.getItem("role");
  if (
    role==="admin"
  ){
    return <Outlet />
  }
   else{
    return  <Navigate to="/" />;
  
   }
};

export default PrivateRoutes;
   